export enum DashboardLoaderKey {
  GET_TASKS = 'get-tasks',
  GET_CRITICAL_ORDERS = 'get-critical-orders',
  GET_NETWORK_HEALTH = 'get-network-health',
  GET_NEW_UPDATES = 'get-new-updates',
}

export enum TaskStatus {
  FAILED = 'Failed',
  NOT_REPORTED = 'Not Reported'
}
